module.exports = __webpack_public_path__ + "img/33_37.5e2b8cc7.png";